﻿// Изменение способа обработки ошибок плагином DataTables
// При возникновении ошибки вместо alert() выкидывать JS-error
// https://datatables.net/reference/event/error
$.fn.dataTable.ext.errMode = "throw";

// Установка стандартных настроек DataTables
// https://datatables.net/examples/advanced_init/defaults.html
$.extend(true, $.fn.dataTable.defaults, {
    // Локализация
    language: {
        decimal: "",
        emptyTable: "Нет данных в таблице",
        info: "Записи с _START_ до _END_ из _TOTAL_ записей",
        infoEmpty: "Записи с 0 до 0 из 0 записей",
        infoFiltered: "(отфильтровано из _MAX_ записей)",
        infoPostFix: "",
        thousands: ",",
        lengthMenu: "Показать _MENU_ записей",
        loadingRecords: "Загрузка...",
        processing: "Подождите...",
        search: "Поиск:",
        searchPlaceholder: "по полям таблицы...",
        zeroRecords: "Записи отсутствуют",
        paginate: {
            first: "Первая",
            last: "Последняя",
            next: "Следующая",
            previous: "Предыдущая",
        },
        aria: {
            sortAscending:
                ": активировать для сортировки столбца по возрастанию",
            sortDescending:
                ": активировать для сортировки столбцов по убыванию",
        },
    },

    // Отложенный рендеринг строк
    deferRender: true,

    // Сохранение состояния в LocalStorage
    stateSave: true,

    // Количество строк на страницу по умолчанию
    pageLength: 25,

    // Варианты выбора числа строк на страницу
    lengthMenu: [
        [10, 25, 50, 100, -1],
        [10, 25, 50, 100, "все"],
    ],

    // Подсветка поисковых результатов
    // используется плагин jquery.mark
    // https://github.com/julmot/jquery.mark
    // https://datatables.net/reference/option/drawCallback
    drawCallback: function () {
        var api = this.api();

        var keyword = api.search();
        var $body = $(api.table().body());

        $body.unmark();
        $body.mark(keyword);
    },
});

// Хелпер для отображения даты в виде тега <abbr>
// TODO: Передалать к собственному типу колонок (https://datatables.net/reference/option/columns.type)
function displayDateAsAbbr(date, longFormat, shortFormat) {
    // Для отсутствующих дат выводим прочерк
    if (!date) {
        return "&ndash;";
    }

    var _date = dayjs(date);

    // Проверка даты
    if (!_date.isValid()) {
        return "Некорректная дата";
    }

    return (
        '<abbr title="' +
        _date.format(longFormat) +
        '">' +
        _date.format(shortFormat) +
        "</abbr>"
    );
}
